export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"theme-color","content":"#FFFFFF"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png"},{"rel":"preconnect","href":"https://tagging.ballegooyenmodes.com"},{"rel":"dns-prefetch","href":"https://navigator-analytics.tweakwise.com"},{"rel":"preconnect","href":"https://navigator-analytics.tweakwise.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://www.kiyoh.com"},{"rel":"preload","href":"/fonts/PPMori-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/PPMori-SemiBold.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/PPMonumentExtended-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"}],"style":[],"script":[{"type":"text/javascript","innerHTML":"(function(){function t(t,e,r){if(\"cookie\"===t){var n=document.cookie.split(\";\");for(var o=0;o<n.length;o++){var i=n[o].split(\"=\");if(i[0].trim()===e)return i[1]}}else if(\"localStorage\"===t)return localStorage.getItem(e);else if(\"jsVariable\"===t)return window[e];else console.warn(\"invalid uid source\",t)}function e(e,r,n){var o=document.createElement(\"script\");o.defer=!0,o.src=r,e.insertBefore(o,n)}function r(r,n,o,i,a){var c,s=!1;try{var u=navigator.userAgent,f=/Version\\/([0-9\\._]+)(.*Mobile)?.*Safari.*/.exec(u);f&&parseFloat(f[1])>=16.4&&(c=t(o,i,\"\"),s=!0)}catch(t){console.error(t)}var l=window[a]=window[a]||[];l.push({\"gtm.start\":(new Date).getTime(),event:\"gtm.js\"});var g=r+\"/SDNISjUyJmVu.js?tg=\"+n+(s?\"&enableCK=true\":\"\")+(c?\"&mcookie=\"+encodeURIComponent(c):\"\"),d=document.getElementsByTagName(\"script\")[0];e(d.parentNode,g,d)}r('https://tagging.ballegooyenmodes.com',\"NM3FXZ\",\"cookie\",\"_taggingmk\",\"dataLayer\")})();","defer":true,"tagPosition":"bodyClose"},{"src":"https://tagging.ballegooyenmodes.com/user-data-minified.js","defer":true,"tagPosition":"bodyClose"},{"key":"varify-init","type":"text/javascript","innerHTML":"window.varify = window.varify || {}; window.varify.iid = 5769;","tagPosition":"bodyClose"},{"src":"https://app.varify.io/varify.js","defer":true,"tagPosition":"bodyClose"}],"noscript":[],"__dangerouslyDisableSanitizersByTagID":{"inline-script":["innerHTML"],"varify-init":["innerHTML"]},"htmlAttrs":{"lang":"nl"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true